export const getError = (name?: string): string|undefined => window?.ERRORS?.[name as keyof Errors];